import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 13l8 -3l8 3","key":"svg-0"}]]

const IconChevronCompactUp = createReactComponent('outline', 'chevron-compact-up', 'ChevronCompactUp', __iconNode);

export default IconChevronCompactUp;